import { AnalyticsService } from "@23degrees/shared/services/analytics";
import { ApplicationRef, EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";

export const provide23init = (): EnvironmentProviders => {
  
    const providers = [
      provideAppInitializer(async () => {
        const analyticsService = inject(AnalyticsService);
        const router = inject(Router);
        const appRef = inject(ApplicationRef);
        let prevEvent: NavigationEnd | null = null;

        const sub = router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
            analyticsService.handleRouterEvent(event, prevEvent);
            prevEvent = event as NavigationEnd;
        });

        appRef.onDestroy(() => {
            sub.unsubscribe();
        });
      }),
    ];
    return makeEnvironmentProviders(providers);
  };